/******/
(() => { // webpackBootstrap
    var __webpack_exports__ = {};
    Shopify.theme.jsVideo = {
        init: function($section) {

            // Add settings from schema to current object
            Shopify.theme.jsVideo = $.extend(this, Shopify.theme.getSectionData($section));

            // Selectors
            const $videoElement = $section.find('[data-video-element]');
            const $playIcon = $section.find('.plyr--paused.plyr--video .plyr__control--overlaid');
            const $playButtons = $section.find('[data-play-button]');
            const $textElement = $section.find('[data-text-element]');
            const $imageElement = $section.find('[data-image-element]');
            // Load video if the media has been added
            if (this.iframe_video || this.html5_video && isScreenSizeLarge()) {
                this.loadVideo($videoElement, $playIcon, $textElement, $imageElement, $playButtons);
            } else {
                $imageElement.show();
                $videoElement.hide();
            }

        },
        loadVideo: function($videoElement, $playIcon, $textElement, $imageElement, $playButtons) {
          let {aspect_ratio ,autoloop , autoplay , id , mute , poster } = this
            const player = new Plyr(`.video-${id}`, {
                controls: videoControls,
                loop: {
                    active: autoloop
                },
                fullscreen: {
                    enabled: true,
                    fallback: true,
                    iosNative: true
                },
                storage: {
                    enabled: false
                }
            });

            player.muted = mute;
            player.ratio = aspect_ratio;

            // If autoplay enabled, hide image and text
            if (autoplay) {
                player.autoplay = true;
                let forcedPlay = setInterval(function(){
                  if(player.paused){
                  	player.play()
                  }else{
                  	clearInterval(forcedPlay)
                  }
                },500)
                $imageElement.hide();
                $videoElement.show();
                $playButtons.hide()
            } else {
                // If autoplay disabled, check if poster image added
                if (poster) {
                    $videoElement.hide();
                    $imageElement.show();
                    $playButtons.show()
                } else {
                    // If autoplay disabled and no poster image
                    $imageElement.hide();
                    $videoElement.show();
                    $playButtons.show()
                }
            }
            // Clicking anywhere on video should play the video
            if ($playButtons.length) {
              $playButtons.on('click', () => {
                  player.play();
              })
            } else {
              $imageElement.on('click', () => {
                  player.play();
              })
            }

            player.on('ready', function(index, player) {
                if ($playButtons.length) {
                    $videoElement.closest('.video-wrapper').find('.plyr--paused.plyr--video .plyr__control--overlaid').hide();
                } else {
                    $videoElement.closest('.video-wrapper').find('.plyr--paused.plyr--video .plyr__control--overlaid').show();
                }
            });

            // On play, hide image/text and show video element
            player.on('play', function(index, player) {
                $videoElement.show();
                $imageElement.hide();
                $playButtons.hide()
                if (!autoplay) {
                    $textElement.hide()
                }
            }.bind(this))
            
            player.on('pause', function(index, player) {
              if(autoplay){
              	player.play()
              }else{
                $videoElement.closest('.video-wrapper').find('.plyr--paused.plyr--video .plyr__control--overlaid').show();
              }
            }.bind(this))

        },
        unload: function($section) {
            const $textContainer = $section.find('[data-video-text-container]');
            $textContainer.off();
        }
    }

    /******/
})();